var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tab-pane",
    { staticClass: "q-pb-sm q-pa-none", attrs: { name: "members" } },
    [
      _c(
        "div",
        {
          staticClass:
            "bg-blue-grey-11 text-blue-grey-14 q-pa-md row items-center"
        },
        [
          _c("q-icon", {
            staticStyle: { "font-size": "1.25rem" },
            attrs: { name: "info" }
          }),
          _c("span", { staticClass: "on-right" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("member_count")) + " "),
            _c("span", { staticClass: "text-weight-bold" }, [
              _vm._v(_vm._s(_vm.memberCount))
            ]),
            _vm._v(" " + _vm._s(_vm.$tc("member", _vm.memberCount)) + "\n    ")
          ])
        ],
        1
      ),
      _c("team-member-list", {
        staticClass: "q-py-sm",
        attrs: { team: _vm.team }
      }),
      _c("invite-member", { staticClass: "q-px-md", attrs: { team: _vm.team } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }